'use client';

import posthog, { initPostHog } from '@/lib/posthog';
import dynamic from 'next/dynamic';
import { PostHogProvider } from 'posthog-js/react';
import { type ReactNode } from 'react';

const PostHogPageView = dynamic(() => import('@/app/PostHogPageView'), {
  ssr: false,
});

const PostHogUserIdentifier = dynamic(
  () =>
    import('./PostHogUserIdentifier').then((mod) => ({
      default: mod.PostHogUserIdentifier,
    })),
  { ssr: false }
);

export function PostHogClientWrapper({ children }: { children: ReactNode }) {
  // Initialize PostHog on the client side
  // This is safe to call multiple times as initPostHog handles duplicate initialization
  if (typeof window !== 'undefined') {
    initPostHog();
  }

  return (
    <PostHogProvider client={posthog}>
      <PostHogPageView />
      <PostHogUserIdentifier />
      {children}
    </PostHogProvider>
  );
}
